import {useServerAction} from 'src/hooks/useServerFormAction';
import suggestPlace from 'server/serverActions/suggestPlace';
import type {MapLoadingPlace} from './useMap';
import {closeLine} from 'src/utils/icons';
import BaseButton from '../BaseButton';

type Props = {
  loadingPlace: MapLoadingPlace;
  unSelectPlace: () => void;
};

const MapPlaceCardEmptyState = ({loadingPlace, unSelectPlace}: Props) => {
  const {action, isPending, data: isSuggested} = useServerAction(suggestPlace);

  const suggestThisPlace = () => {
    return action({name: loadingPlace.name, location: loadingPlace.location});
  };

  return (
    <div className="flex flex-col gap-1 p-1">
      <h3 className="text-xl">{loadingPlace.name}</h3>
      <span className="text-(--gray-text)">is not on Humbo just yet. Is it worth a visit?</span>

      <div className="grow" />

      {isSuggested ? (
        <div className="mt-4">🙏 Thank you! We will look into it.</div>
      ) : (
        <BaseButton
          buttonVariant="secondary"
          size="small"
          className="mt-4"
          onPress={suggestThisPlace}
          isLoading={isPending}
          disabled={isPending}
        >
          Please add this place!
        </BaseButton>
      )}

      <BaseButton
        onPress={unSelectPlace}
        icon={closeLine}
        buttonVariant="secondary"
        className="w-[32px] h-[32px] absolute right-4 top-4"
      />
    </div>
  );
};

export default MapPlaceCardEmptyState;
